import styled from "@emotion/styled";
import { ReactMFE } from "@tpd-web-common-libs/nodejs-library";
import { Styles } from "@tpd-web-common-libs/nodejs-library";

export const ContainerDiv = styled.div`
  display: flex;
  height: 100px;
  width: 100%;

  ${Styles.BreakpointsUtils.mobileAndTabletOnly(`
    display: none;
  `)}
`;

export const LeftContent = styled.div`
  width: calc(100% * 7 / 24);
  height: 100%;
`;

export const CenterContent = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% * 10 / 24);
`;

export const RightContent = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% * 7 / 24);
`;

export const LogoWrapper = styled(ReactMFE.Link)`
  display: flex;
  justify-content: center;
  height: 100%;
  width: 100%;
  color: unset;
  text-decoration: none;
`;

export const Logo = styled.img`
  height: 60px;
  margin-top: 20px;
  aspect-ratio: 7 / 2;
`;

export const CenterContentContainer = styled.div`
  padding: 0 46px;
`;

export const CenterTopContent = styled.div`
  color: ${Styles.Themes.UnipolColors.blueOne};
  ${Styles.TouchpointUtils.touchpointThemeOnly(
    (touchpoint: any) => `
    color: ${touchpoint.mainColor};
  `
  )}
  height:50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Unipol Medium;
  width: 100%;
`;

const mainMenuHeight = 50;
export const MainMenu = styled.div`
  display: flex;
  justify-content: space-between;
  height: ${mainMenuHeight}px;
  position: relative;
  flex-direction: row;
  border-bottom: 1px solid white;
`;

export const DropdownContainer = styled.div`
  display: flex;
  padding: 0;
  height: 100%;
  justify-content: center;
  &:first-of-type {
    padding-left: 0px;
    justify-content: start;
  }
  &:last-of-type {
    padding-right: 0px;
    justify-content: end;
  }
  &:hover {
    > div {
      display: block;
      opacity: 1;
    }
  }
`;

const MenuLinkStamp = `
color: ${Styles.Themes.UnipolColors.blueOne};
${Styles.TouchpointUtils.touchpointThemeOnly(
  (touchpoint: any) => `
    color: ${touchpoint.mainColor};
  `
)}
  font-size: 16px;
  font-family: Unipol Medium;
  line-height: ${mainMenuHeight}px;
  height: 100%;  
  text-decoration: none;
  text-transform: uppercase;
  cursor: pointer;


  &:hover {
    height: auto;
    padding-bottom: 8px;
  }
`;

export const MenuLink = styled(ReactMFE.Link)`
  ${MenuLinkStamp}
  &:hover, &.selectedLink {
    border-bottom: 8px solid ${(props) => props.color};
    color: ${(props) => props.color};
  }

  &.main-theme,
  &.hover-main-theme:hover {
    border-bottom: 8px solid ${Styles.Themes.UnipolColors.blueOne};
    color: ${Styles.Themes.UnipolColors.blueOne};
  }
`;

const menuWidth = 900;
const menuPaddingLeftOrRight = 30;
const Menu = `
  display: none;
  position: absolute;
  background-color: #fff;
  top: ${mainMenuHeight}px;
  left: calc(50% - ${menuWidth / 2}px);
  min-height: 436px;
  overflow: hidden;
  padding: 15px ${menuPaddingLeftOrRight}px;
  width: ${menuWidth - 2 * menuPaddingLeftOrRight}px;
  opacity: 0;
  transition: opacity 2s;
  z-index: ${Styles.Constants.headerZIndex};
`;

export const MenuDropdown = styled.div`
  ${Menu}
  border-top: 8px solid ${(props) => props.color};
`;

export const RightTopContent = styled.div`
  height: 59px;
`;

export const CtaWrapper = styled.div`
  display: flex;
  height: 50px;
  margin-bottom: 1px;
`;

export const MenuTitleContainer = styled.div`
  border-bottom: 1px solid ${(props) => props.color};
  align-items: center;
  display: flex;
  height: auto;
  margin-bottom: 30px;
  padding-bottom: 5px;
  width: 100%;

  &.main-theme {
    border-bottom: 2px solid ${Styles.Themes.UnipolColors.blueOne};
  }
`;

export const MenuIconWrapper = styled.div`
  position: relative;
  background-color: ${(props) => props.color};
  height: 35px;
  width: 35px;
  color: #fff;

  &.main-theme {
    color: ${Styles.Themes.UnipolColors.blueOne};
  }

  &.bkc_cerchio {
    border-radius: 50%;
  }

  &.bkc_rombo {
    transform: rotate(45deg);
    i {
      transform: rotate(-45deg);
    }
  }
`;

export const MenuIcon = styled.i`
  position: absolute;
  font-size: 20px;
  left: 22%;
  top: 21%;
`;

export const MenuTitle = styled(ReactMFE.Link)`
  margin-left: 10px;
  color: ${(props) => props.color};
  text-decoration: none;
  font-weight: 700;
  font-family: Unipol Medium;
  font-size: 16px;
  text-transform: uppercase;

  &.main-theme {
    color: ${Styles.Themes.UnipolColors.blueOne};
  }
`;

export const MenuGridContainer = styled.div`
  display: grid;
  column-gap: 10px;
  grid-template-columns: repeat(4, 1fr);
  row-gap: 30px;

  &.main-theme {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const SubMenuTitle = styled(ReactMFE.Link)`
  display: block;
  text-decoration: none;
  color: ${(props) => props.color};
  font-family: Unipol Medium;
  font-size: 15px;
  line-height: 1.4;
  margin-bottom: 10px;
  text-transform: uppercase;

  &:hover {
    color: ${(props) => props.color};
  }

  &.main-theme {
    color: ${Styles.Themes.UnipolColors.blueOne};
  }

  &.underline {
    border-bottom: 2px solid ${(props) => props.color};
  }
`;

export const SubMenuLink = styled(ReactMFE.Link)`
  display: block;
  color: #4a4a4a;
  font-family: Unipol Medium;
  font-size: 13px;
  line-height: 1.4;
  text-transform: uppercase;
  text-decoration: none;
  margin-bottom: 13px;

  &:hover {
    color: inherit;
  }
`;

export const Cta = styled(ReactMFE.Link)`
  background-color: ${Styles.Themes.UnipolColors.blueOne};
  ${Styles.TouchpointUtils.touchpointThemeOnly(
    (touchpoint: any) => `
    background-color: ${touchpoint.mainColor};
  `
  )}
  display: inline-block;
  height: 50px;
  width: 13%;
  color: #fff;
  cursor: pointer;
  font-size: 50px;
  line-height: 50px;
  text-align: center;
  border-left: 1px solid #fff;
  overflow: hidden;
  text-decoration: none;

  &:hover {
    color: #fff;
    text-decoration: none;
  }}

  ${Styles.BreakpointsUtils.mobileOnly(`
    font-size : 24px;
  `)}
`;

export const LoginHome = styled.div`
  background-color: ${Styles.Themes.UnipolColors.blueOne};
  ${Styles.TouchpointUtils.touchpointThemeOnly(
    (touchpoint: any) => `
      background-color: ${touchpoint.mainColor};
  `
  )}
  position: relative;
  display: inline-block;
  font-family: Unipol;
  color: #fff;
  border-left: 1px solid #fff;
  cursor: pointer;
  font-size: 15px;
  height: 50px;
  line-height: 50px;
  padding-left: 10px;
  text-transform: uppercase;
  width: 76%;
`;
export const CartIcon = styled.i`
  content: url("/NextAssets/icons/icon-Cart.svg");
  height: 30px;
  display: block;
  margin: 10px auto;
  filter: brightness(99);
`;
